const DEVICE_TYPE = {
    PC: 'pc',
    OTHER: 'other',
    IPHONE_NATIVE: 'iphone',
    IPHONE: 'iphone',
    IPAD_NATIVE: 'ipad',
    IPAD: 'ipad'
};


enum DEVICE_ENUM_TYPE {
    NON = 0,
    IOS = 1,
    ANDROID = 2
};

const NATIVE_TYPE = {
    CASINO_IOS: 'cbCallBackHandlerCGP',
    CASINO_ANDROID: 'WrapperInterfaceCGP',
    POKER_IOS: 'NativeInterface',
    POKER_ANDROID: 'NativeInterface',
    CIP8_ANDROID: 'pokerNativeInterface',//TODO - will be also used in CGP so that we have a unique source
    SPORT_IOS: 'callbackHandler',
    SPORT_IOS_EMBEDDED: 'sportHybridOnly',
    SPORT_ANDROID: 'WrapperInterface'
};

const DEVICE_GNWP_TYPE = {
    HYBRID_IOS_EMBEDDED: 'hybrid_ios_embedded',
};

export interface DeviceType {
    deviceType: string;
    operationSystem: string;
    tool?: string;
    isHybrid: boolean;
    isEmbeddedHybrid: boolean;
    isHybridPoker: boolean;
}

export interface ClientHints {
    architecture: string,
    brand: string,
    model: string,
    platform: string,
    version: string
}

export {DEVICE_TYPE, DEVICE_ENUM_TYPE, NATIVE_TYPE, DEVICE_GNWP_TYPE};
